export const GET_NOTIFICATIONS_SUCCESS = 'notifications/GET_NOTIFICATIONS_SUCCESS';
export const REMOVE_NOTIFICATION_SUCCESS = 'notifications/REMOVE_NOTIFICATION_SUCCESS';